var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPageName === 'project')?_c('v-sheet',{attrs:{"color":_vm.backgroundColor}},[(_vm.reportPath !== 'profile')?_c('report-container',{attrs:{"actions":_vm.actions},scopedSlots:_vm._u([{key:"report-modals",fn:function(){return [_c('project-modal')]},proxy:true}],null,false,3111011328)}):_c('project-profile')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }